import React from 'react';
import ServicePage from './ServicePage';
export default function GeneralContractorMiami() {
  return <ServicePage slug="general-contractor-miami" />;
}
